import { Mutex } from "async-mutex";

/**
 * A mutex to serialize core video SDK operations like audio/video
 * initialization, media element attachment/detachment, joining/leaving rooms,
 * etc. across parts of the application that run concurrently e.g. operations
 * that run reactively and user-initiated operations.
 */
export const videoSDKMutex = new Mutex();
